import { NextSeo } from 'next-seo'
import { useState } from 'react'

import AuthBg from '@/assets/illustrations/auth.svg'
import Button, { ButtonVariant } from '@/components/button'
import useToggle from '@/hooks/use-toggle'
import protectedRoute from '@/utils/protected-route'

import RequestCode from './components/request-code'
import ResetPassword from './components/reset-password'

const ForgotPassword = () => {
  const [hasCode, toggleHasCode] = useToggle(false)
  const [submittedEmail, updateSubmittedEmail] = useState('')

  return (
    <div className='align-center flex h-[100%] min-h-full flex-wrap bg-theme-turquoise  px-5'>
      <NextSeo title='Forgot Password' />
      <div className='py-custom flex-[0_0_100%]'>
        <div className='flex justify-between self-center'>
          <div>
            <Button
              variant={ButtonVariant.Primary}
              bg='bg-[#234370]'
              tailFill='#234370'
              className='cm-bg px-1.5 py-0.5 text-white'
              tailClassName='right-[unset] left-0 scale-x-[-1] -translate-x-[50%] translate-y-[41%] h-2'
            >
              <span className='translate-y-0.5'>Forgot password?</span>
            </Button>
          </div>
        </div>
        {!hasCode ? (
          <RequestCode
            toggleHasCode={toggleHasCode}
            updateSubmittedEmail={updateSubmittedEmail}
          />
        ) : (
          <ResetPassword submittedEmail={submittedEmail} />
        )}
      </div>
      <div className='flex-[0_0_100%] self-end'>
        <img src={`${AuthBg.src}`} className='mx-auto' />
      </div>
      <style jsx>
        {`
          .py-custom {
            max-width: 524px;
            margin: 200px auto 20px;
          }
          @media (max-width: 1920px) {
            .py-custom {
              max-width: calc(
                320px + (524 - 320) * (100vw - 375px) / (1920 - 375)
              );
              margin: calc(115px + (200 - 115) * (100vw - 375px) / (1920 - 375))
                auto 20px;
            }
          }
        `}
      </style>
    </div>
  )
}

export default protectedRoute(ForgotPassword, { preventLoggedInUsers: true })
